import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SubjectService } from './subject.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isLogin = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private subject: SubjectService
  ) { }

  login(body: any): any {
    if (body.username === "user" && body.password === "user") {
      this.isLogin = true;
      localStorage.setItem('STATE', 'true');
      localStorage.setItem('ROLE', '');
      this.subject.setAccessSubject(true);
      this.router.navigate(['trai-reports']);
    }
    else {
      window.alert("Invalid Credentials");
      this.subject.setAccessSubject(false);
      this.isLogin = false;
    }
  }

  // login(body: any): any {
  //   // slice to remove /api from endpoint for auth API
  //   let url = environment.apiEndpointRdbms.slice(0, environment.apiEndpointRdbms.length - 4);
  //   url += body.ismso ? 'auth/mso/login' : 'auth/lco/login';
  //   this.http.post(url, body).subscribe(
  //     (data: any) => {
  //       this.isLogin = true;
  //       localStorage.setItem('STATE', 'true');
  //       localStorage.setItem('TOKEN', data.token);

  //       if (!body.ismso) {
  //         // LCO
  //         window.localStorage.setItem('lco', btoa(JSON.stringify(data.currentUser)));
  //         window.localStorage.setItem('id', btoa(data.currentUser.id));
  //         localStorage.setItem('ROLE', GlobalConstants.LCO);
  //       } else {
  //         // MSO
  //         localStorage.setItem('ROLE', GlobalConstants.MSO);
  //       }

  //       this.subject.setAccessSubject(true);
  //       this.router.navigate(['trai-reports']);
  //     },
  //     (err: HttpErrorResponse) => {
  //       window.alert(err.error.message);
  //       this.subject.setAccessSubject(false);
  //       this.isLogin = false;
  //       localStorage.setItem('STATE', 'false');
  //       localStorage.setItem('ROLE', '');
  //     });
  // }

  logout(): any {
    this.subject.setAccessSubject(false);
    this.isLogin = false;
    localStorage.clear();
    localStorage.setItem('STATE', 'false');
    localStorage.setItem('ROLE', '');
  }

  isLoggedIn(): any {
    const loggedIn = localStorage.getItem('STATE');
    if (loggedIn === 'true') {
      return true;
    } else {
      return false;
    }
  }

  getRole(): string {
    return localStorage.getItem('ROLE');
  }

  isLCO(): boolean {
    if (this.getRole() === 'LCO') {
      return true;
    }
    return false;
  }

  getUserData(): any {
    // if (this.getRole() === 'LCO') {
    const lco = atob(window.localStorage.getItem('lco'));
    return JSON.parse(lco);
    // }
  }

  getToken(): string {
    return localStorage.getItem('TOKEN');
  }

  getLcoId(): string {
    return atob(localStorage.getItem('id'));
  }

}
